import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from '../../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import documentLink from '../../../../utils/documentLink';
import Icon from '../../../common/Icon.vue';
import selectedIcon from '../../../../assets/icon/selected.svg';
import { groupIntroConfig } from './config';
import { isUniFrameWork } from '../../../../utils/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  groupType: {
    type: String,
    default: '',
  },
},
  emits: ['selectType'],
  setup(__props, { emit }) {

const props = __props



const type = groupIntroConfig;

const selectType = ref();



watchEffect(() => {
  selectType.value = props.groupType;
});

const selected = (item: any) => {
  selectType.value = item.type;
  emit('selectType', item.type);
};

const openUrl = (link: string) => {
  if (!isUniFrameWork) {
    TUIGlobal?.open(link);
  }
};


return { __sfc: true,props, type, selectType, emit, selected, openUrl, TUITranslateService, documentLink, Icon, selectedIcon }
}

})